

<div class="lifebasebegin">
  <!-- Show an error message if there is one -->
  <div *ngIf="errorMessage">
    <p>{{ errorMessage }}</p>
  </div>

  <!-- If no error, display the retrieved content -->
  <div *ngIf="!errorMessage">
    <div [innerHTML]="safeContent"></div>
  </div>
</div>
<br />
<a routerLink="dashboard" class="btn btn-sm btn-secondary">
    Take me Back
  </a>
<!-- 
  <div *ngIf="errorMessage; else contentBlock">
    <p>{{ errorMessage }}</p>
  </div>
  <ng-template #contentBlock>
    !-- Use innerHTML binding to display the sanitized content --
    <div [innerHTML]="safeContent"></div>
  </ng-template>
  

  !-- src/app/components/page-content/page-content.component.html --
<div class="page-content">
  !-- Render content as HTML if needed --
  <div [innerHTML]="safeContent"></div>
</div>

-->
<!--
<app-page-content LifebasebeginComponent="home"></app-page-content>
-->


